import { render, staticRenderFns } from "./Powerbox.vue?vue&type=template&id=79c3fbf1&scoped=true"
import script from "./Powerbox.vue?vue&type=script&lang=js"
export * from "./Powerbox.vue?vue&type=script&lang=js"
import style0 from "./Powerbox.vue?vue&type=style&index=0&id=79c3fbf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c3fbf1",
  null
  
)

export default component.exports